import React, { createContext, useContext, useReducer, useEffect } from 'react';

const MessageContext = createContext();

const messageReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_MESSAGE':
      return {
        ...state,
        messages: [
          ...state.messages,
          {
            id: Date.now() + Math.random(),
            text: action.payload.text,
            type: action.payload.type, // 'success', 'error', 'info', 'warning'
            autoDismiss: action.payload.autoDismiss !== undefined ? action.payload.autoDismiss : true,
            duration: action.payload.duration || 5000
          }
        ]
      };
    case 'REMOVE_MESSAGE':
      return {
        ...state,
        messages: state.messages.filter(message => message.id !== action.payload.id)
      };
    case 'CLEAR_MESSAGES':
      return {
        ...state,
        messages: []
      };
    default:
      return state;
  }
};

export const MessageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(messageReducer, { messages: [] });

  // Manejar el auto-dismiss de mensajes
  useEffect(() => {
    const timers = state.messages
      .filter(message => message.autoDismiss)
      .map(message => {
        const timer = setTimeout(() => {
          dispatch({ type: 'REMOVE_MESSAGE', payload: { id: message.id } });
        }, message.duration);
        return { id: message.id, timer };
      });

    return () => {
      timers.forEach(({ timer }) => clearTimeout(timer));
    };
  }, [state.messages]);

  const showMessage = (text, type = 'info', options = {}) => {
    dispatch({
      type: 'ADD_MESSAGE',
      payload: {
        text,
        type,
        autoDismiss: options.autoDismiss,
        duration: options.duration
      }
    });
  };

  const removeMessage = (id) => {
    dispatch({ type: 'REMOVE_MESSAGE', payload: { id } });
  };

  const clearMessages = () => {
    dispatch({ type: 'CLEAR_MESSAGES' });
  };

 return (
    <MessageContext.Provider value={{ messages: state.messages, showMessage, removeMessage, clearMessages }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
  return context;
};
